export const MOTION_EASE = [0.25, 1, 0.5, 1] as const;

export const DRAFT_STALE_TIME_MS = 5 * 60 * 1000;

export const SEGMENT_LIMITS = {
  rules: 10,
  conditions: 10,
} as const;

export const SEGMENT_MODE = {
  VIEW: "view",
  EDIT: "edit",
} as const;

export type SegmentMode = (typeof SEGMENT_MODE)[keyof typeof SEGMENT_MODE];

export const TAB_PARAM = "tab";

export const SEGMENT_TAB = {
  RULES: "rules",
  VACANCIES: "vacancies",
  HISTORY: "history",
} as const;

export type SegmentTab = (typeof SEGMENT_TAB)[keyof typeof SEGMENT_TAB];

export const LOGIC = {
  AND: "AND",
  OR: "OR",
} as const;

export type Logic = (typeof LOGIC)[keyof typeof LOGIC];

export const SEGMENT_TRANSITION = {
  duration: 0.18,
  ease: [0.25, 1, 0.5, 1],
} as const;

export const FADE_TRANSITION = {
  duration: 0.3,
  ease: [0.22, 1, 0.36, 1],
} as const;

export const PLACEHOLDER_DELAY_S = 0.15;

export const VACANCY_OVERRIDE = {
  INCLUDE: "Include",
  EXCLUDE: "Exclude",
} as const;

export type VacancyOverrideType =
  (typeof VACANCY_OVERRIDE)[keyof typeof VACANCY_OVERRIDE];

export const LIST_PARAM = "list";

export const VACANCY_LIST = {
  INCLUDED: "Included",
  EXCLUDED: "Excluded",
} as const;

export type VacancyListKind = (typeof VACANCY_LIST)[keyof typeof VACANCY_LIST];

export const VACANCY_FILTER_KEY = {
  OVERRIDE: "override",
  FIELD: "field",
  CITY: "city",
  COMPANY: "company",
} as const;

export type VacancyFilterKey =
  (typeof VACANCY_FILTER_KEY)[keyof typeof VACANCY_FILTER_KEY];

export const VACANCY_FILTER_KEYS: VacancyFilterKey[] =
  Object.values(VACANCY_FILTER_KEY);
